export default "__VITE_ASSET__DhdGD49u__"